import type { EffectParams } from '@swf/core/store';
import type { CasinoGameInstance } from '@swf/core/types/CasinoGame';
import { JoinReason } from '@swf/core/types/CasinoGame';
import { getWindow } from '@swf/core/utils/casino';

const reconnect = async (
  payload: { instance: CasinoGameInstance },
  { rootState, dispatch, select }: EffectParams
) => {
  const { instance } = payload;
  const isMobile = select.device.isMobile(rootState);
  const isEmbedded = select.device.isEmbedded(rootState);
  const windowRef = getWindow({ table: instance, isMobile, isEmbedded });
  dispatch.casino.open({ instance, joinReason: JoinReason.Play, windowRef });
};

export default reconnect;
